module.exports = __webpack_public_path__ + "img/25_34.c643f2e0.png";